<template>
  <div class="box-card-content">
    <div class="sumAll">
      <div class="box-card-item">
        <div class="title">收款汇总</div>
        <div v-for="(item,key) in sum" :key="key" class="card-item-text">
          <div v-if="!item.showI">{{item.title}}：{{item.value}}{{item.unit}}</div>
          <el-popover
            v-else
            popper-class="mergs-detail1-sum-pop"
            placement="top"
            trigger="hover">
            <div class="pop-container">
              <div class="pop-des"  v-for="(i, k) in item.showI" :key="k">{{i.title}}：{{i.value}}{{i.unit}}</div>
            </div>
            <div class="mergs-detail-pop-title" slot="reference">{{item.title}}<i class="el-icon-question"></i>：{{item.value}}{{item.unit}}</div>
          </el-popover>
        </div>
      </div>
    </div>
    <div class="sumAll">
      <div class="box-card-item">
        <div class="title">退款汇总</div>
        <!-- <div v-for="(item,key) in refund" :key="key" class="card-item-text">
          {{item.title}}：{{item.value}}{{item.unit}}
        </div> -->
        <div class="g-flx">
          <div>
            <div v-for="(item,key) in onDutyRefund" :key="key" class="card-item-text">
              {{item.title}}：{{item.value || 0}}{{item.unit}}
            </div>
          </div>
          <div style="margin-left: 50px">
            <div v-for="(item,key) in notDutyRefund" :key="key" class="card-item-text">
              {{item.title}}：{{item.value || 0}}{{item.unit}}
            </div>
          </div>
        </div>

        <p class="title" style="color: #7a7a7a">合计</p>
        <div class="g-flex-sb">
          <div v-for="(item,key) in refund" :key="key" class="card-item-text">
            {{item.title}}：{{item.value}}{{item.unit}}
          </div>
        </div>
      </div>
    </div>
    <div class="sumAll" v-if="isShowSum">
      <div class="box-card-item">
        <div class="title">结算汇总</div>
        <div v-for="(item,key) in settle" :key="key" class="card-item-text width_200">
          <div v-if="!item.showI">{{item.title}}：{{item.value}}{{item.unit}}</div>
          <el-popover
            popper-class="mergs-detail1-set-pop"
            placement="top"
            v-else
            trigger="hover">
            <div class="pop-container">
              <div class="pop-des" v-for="(i, k) in item.showI" :key="k">{{i.title}}{{i.value}}{{i.unit}}</div>
            </div>
            <div class="mergs-detail-pop-title" slot="reference">{{item.title}}<i class="el-icon-question"></i>：{{item.value}}{{item.unit}}</div>
          </el-popover>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import mixin from '../mixins'
export default {
  mixins: [mixin],
  props:{
    czbGasDutyRecord: {
      type: Object
    },
    isShowSum: {
      type: Boolean
    },
    isGas: {
      type: Number
    },
    haveTiktokVerifyInfo: {
      type: Boolean
    },
    modelActiveType: {
      type: Number
    }
  },
  data () {
    return {
      noVal: ['', null, undefined],
    }
  },
  watch: {
    czbGasDutyRecord (val) {
      this.setDataAll(val)
    },
    isGas (val) {
      this.sum.totalGunAmount.title = val === 2 ? '加气金额汇总' : '加油金额汇总'
      this.sum.orderCount.title = val === 2 ? '加气笔数' : '加油升数'
      this.sum.totalLitre.title = val === 2 ? '加气数量汇总' : '加油升数汇总'
      this.sum.totalLitre.unit = val === 2 ? '' : '升'
      this.refund.totalRefundLitre.title = val === 2 ? '退款数量汇总' : '退款升数汇总'
      this.refund.totalRefundLitre.unit = val === 2 ? '' : '升'
      this.onDutyRefund.periodRefundLitre.title = val === 2 ? '当班退款数量' : '当班退款升数'
      this.onDutyRefund.periodRefundLitre.unit = val === 2 ? '' : '升'
      this.notDutyRefund.otherRefundLitre.title = val === 2 ? '非当班退款数量' : '非当班退款升数'
      this.notDutyRefund.otherRefundLitre.unit = val === 2 ? '' : '升'
    }
  },
  methods: {
    // 设置汇总数据
    setDataAll (gasDuty) {
      if ((this.modelActiveType == 1 || this.modelActiveType == 4) && this.haveTiktokVerifyInfo) {
        this.settle = Object.assign({}, this.settleOld, this.dyInfo)
      } else {
        this.settle = { ...this.settleOld }
      }

      let arr = ['sum','refund','settle', 'onDutyRefund', 'notDutyRefund']
      for (let i = 0; i < arr.length; i++) {
        this.setNumber(this[arr[i]],gasDuty) 
      }
    },
    setDefaultValue (unit) {
      switch(unit) {
        case '元':
          return '0.00'
        case '升':
          return '0'
        case '笔':
          return '0'
        default:
          return ''
      }
    },
    // 将返回的总数据设置到每一项中
    setNumber (sum, all) {
      Object.keys(sum).forEach(key => {
        if (!this.noVal.includes(all[key])) {
          sum[key].value = all[key] || this.setDefaultValue(sum[key].unit)
        } else {
          sum[key].value = 0
        }
        if (sum[key].showI) {
          Object.keys(sum[key].showI).forEach(item => {
            if (!this.noVal.includes(all[item])) {
              sum[key].showI[item].value = all[item] || this.setDefaultValue(sum[key].showI[item].unit)
            }
          })
        }
      })
    },
  }
}
</script>
